import { useContext } from 'react'
import { FormattedMessage, defineMessages } from 'react-intl'
import { useTheme } from '@homebot/shared-ui-swashbuckle'
import { AmplitudeContext } from '@homebot/shared-util-quartermaster'
import { OVERLAY_HELPERS } from '../../../../../constants/navigation'
import ImportantNowCard from '../../ImportantNowCard'
import DefaultThemeSvg from './DefaultThemeSvg'
import LightThemeSvg from './LightThemeSvg'
import { SHARE_WIN } from '../../../../../constants/wins'

const shareMessages = defineMessages({
  nav: {
    id: 'ImportantNow.share.nav',
    defaultMessage: 'Share now',
  },
})

const Share = () => {
  const { theme } = useTheme()
  const { ampli } = useContext(AmplitudeContext)

  const Svg = theme.isLightThemeType ? LightThemeSvg : DefaultThemeSvg

  return (
    <ImportantNowCard
      name='Share'
      event={() => ampli?.winClicked({ win_type: SHARE_WIN })}
      svgImage={Svg}
      navTo={OVERLAY_HELPERS.shareHomebot.buildPath()}
      navMessage={shareMessages.nav}
    >
      <FormattedMessage
        id='ImportantNow.spotlight.share'
        defaultMessage='Share Homebot to help friends & family'
      />
    </ImportantNowCard>
  )
}

Share.propTypes = {}

export default Share
